import { Options } from 'vue-class-component';
import SceneWizardStep, { SceneWizardStepEnum } from '../SceneWizardStep';
import plantsClient from '@/core/services/plants';
import { SET_APP_LOADING } from '@/core/store/action-types';
import {
  Condition,
  ConditionDTO,
  ObjectCondition,
  SceneObjectType,
  TimeCondition,
  TriggersAndConditionsRoomItemDTO,
} from '@/../client-generator/generated-clients/plants';
import { HANDLE_REFRESH_PLANT } from '@/core/utils/emitter-events';
import ScenePanelObjects from '../ScenePanelObjects/ScenePanelObjects.vue';
import ScenePanelTime from '../ScenePanelTime/ScenePanelTime.vue';
import SceneStepItemsList from '../SceneStepItemsList/SceneStepItemsList.vue';

import DialogAddTriggerAndCondition from '../DialogAddTriggerAndCondition/DialogAddTriggerAndCondition.vue';

@Options({
  name: 'SceneWizardStep4',
  components: {
    ScenePanelObjects,
    ScenePanelTime,
    SceneStepItemsList,
    DialogAddTriggerAndCondition,
  },
})
export default class SceneWizardStep4 extends SceneWizardStep {
  conditionsList: TriggersAndConditionsRoomItemDTO[] = [];
  isVisibleDialogCondition = false;
  tempConditionDTOToEdit: ConditionDTO | null = null;
  tempConditionToEdit: Condition | null = null;
  SceneWizardStepEnum = SceneWizardStepEnum;

  mounted() {
    this.fetchConditionList();
  }

  get conditionText() {
    if (this.scene?.conditions?.length == 1){
      return this.$t('AppResource.Condition')
    }else{
      return this.$t('AppResource.Conditions')
    }
  }

  async fetchConditionList() {
    try {
      this.$store.dispatch(SET_APP_LOADING, true);
      const response = await plantsClient.sceneConditionsList(
        this.plantId as number
      );

      this.conditionsList = response.conditionsRoomsList as TriggersAndConditionsRoomItemDTO[];
    } catch (error) {
      let messageError = '';
      switch (error.status) {
        case 409:
          this.$emitter.emit(HANDLE_REFRESH_PLANT);
          this.$router.push({
            name: 'page-plant-dashboard',
            params: this.$route.params,
          });
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      if (messageError) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('general.operationError'),
          closable: true,
          life: 3000,
        });
      }
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }

  handleAddCondition(
    condition: ObjectCondition | TimeCondition,
    objectName: string,
    sceneObjectType: SceneObjectType
  ) {
    //TODO: align with xamarin -> guid converted in int?!? -> max + 1?
    const idsArray = (this.scene.conditions?.flatMap(
      (x) => x.conditionParams?.id
    ) ?? []) as number[];
    const uniqueId = idsArray.length ? Math.max(...idsArray) + 1 : 1;
    condition.id = uniqueId;
    this.scene.conditions?.push(
      new ConditionDTO({
        objectName: objectName,
        sceneObjectType: sceneObjectType,
        conditionParams: condition,
      })
    );
  }

  handleEdit(condition: ConditionDTO) {
    this.tempConditionDTOToEdit = condition;
    this.tempConditionToEdit = new Condition(condition.conditionParams);
    this.isVisibleDialogCondition = true;
  }

  handleRemove(condition: ConditionDTO) {
    this.scene.conditions = this.scene.conditions?.filter(
      (x) => x.conditionParams?.id !== condition.conditionParams?.id
    );
  }

  handleDoEditCondition() {
    if (
      !this.tempConditionToEdit ||
      !this.tempConditionDTOToEdit?.conditionParams
    )
      return;

    this.tempConditionDTOToEdit.conditionParams = this.tempConditionToEdit;
  }
}
